import React from 'react';
import { ButtonKVBase } from '@/presentation/components';
import { IconArrowDown } from '@/presentation/components/icons';
import classNames from 'classnames';
import Styles from './btn-dropdown-styles.scss';
const BtnDropdown = ({ title, items }) => {
    const handleOnClick = (event, action) => {
        event.preventDefault();
        if (action)
            action();
    };
    return (React.createElement(ButtonKVBase, { type: 'button', btnBackgroundGradient: "linear-gradient(90deg, #FFA800 0%, #7F1BFF 100%)", rightIcon: React.createElement(IconArrowDown, null), id: "navbarScrollingDropdown", role: "button", "data-bs-toggle": "dropdown", "aria-expanded": "false", dropDownMenu: React.createElement("ul", { className: classNames('dropdown-menu', Styles.dropdownMenu), "aria-labelledby": "navbarScrollingDropdown" }, items.map((item, key) => (React.createElement("li", { key: key },
            React.createElement("a", { className: "dropdown-item", href: "#", onClick: e => handleOnClick(e, item.onClick) }, item.label))))) }, title));
};
export default BtnDropdown;
